import { FC, useEffect, useLayoutEffect, useRef } from 'react';

import { TMessage } from '@/hooks/promptCanvas/types';

import Message from './Message';

type TProps = {
  chatHistory: TMessage[];
};

const Conversation: FC<TProps> = ({ chatHistory }) => {
  const messageContainer = useRef<HTMLDivElement>(null);

  // scroll to bottom
  useEffect(() => {
    if (chatHistory.length > 0) {
      messageContainer.current?.scrollTo({
        top: messageContainer.current?.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [chatHistory]);

  // keeps chat history at the bottom as input bar grows
  useLayoutEffect(() => {
    const scrollToBottom = () => {
      if (messageContainer.current) {
        messageContainer.current.scrollTo({
          top: messageContainer.current?.scrollHeight,
          behavior: 'instant',
        });
      }
    };
    const observer = new ResizeObserver(() => {
      scrollToBottom();
    });

    if (messageContainer.current) {
      observer.observe(messageContainer.current);
    }
    return () => {
      if (messageContainer.current) {
        observer.unobserve(messageContainer.current);
      }
    };
  }, []);

  return (
    <div className="h-full overflow-y-auto" ref={messageContainer}>
      {chatHistory.map((message, index) => (
        <Message key={index} message={message} />
      ))}
    </div>
  );
};

export default Conversation;
